import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useBeforeUnload = (dirty: boolean) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (!dirty || !window) return;
        window.onbeforeunload = () => {
            if (dirty) {
                return t("UNSAVED_CHANGES_MESSAGE");
            }
        };
        return () => {
            if (window) {
                window.onbeforeunload = null;
            }
        };
    }, [ dirty, t ]);
};

